<main class="container-fluid">
  <article class="row mb-1 mt-1 ml-0 mr-0">
    <section
      class="col-sm-12 col-md p-4 mt-5 mb-5 border-right bg-white shadow"
    >
      <img
        src="../../../../../assets/icons/solicitud.png"
        class="d-inline-block img-responsive mr-3"
        alt=""
      />
      <label class="h5">Listado de solicitudes actual</label>
      <form [formGroup]="formSolicitudActual" (ngSubmit)="filtrar()">
        <div class="row">
          <div
            class="form-group col-4"
            *ngIf="authService.getRolUser(adminSuper); else adminCC"
          >
            <label class="small text-secondary font-weight-bold mt-2"
              >Cámara de Comercio</label
            >
            <select
              class="form-control form-control-sm"
              id="codigo_camara"
              formControlName="codigo_camara"
              (ngModelChange)="onConsultarFuncionarios($event)"
            >
              <option class="" [ngValue]="null" selected="true">
                Seleccione
              </option>
              <option
                class=""
                *ngFor="let option of camarasLista; let i = index"
                value="{{ option?.codigo_camara }}"
                [selected]="false"
              >
                {{ option?.desc_camara }}
              </option>
            </select>
          </div>
          <ng-template #adminCC>
            <div class="form-group col-4">
              <label class="small text-secondary font-weight-bold mt-2"
                >Cámara de Comercio</label
              >
              <input
                class="form-control form-control-sm"
                id="funcionario"
                formControlName="desc_camara"
                disabled
              />
            </div>
          </ng-template>
          <div class="form-group col-4">
            <label class="small text-secondary font-weight-bold mt-2"
              >Funcionario</label
            >
            <select
              class="form-control form-control-sm"
              id="funcionario"
              formControlName="funcionario"
            >
              <option class="" [ngValue]="null" selected="true">
                Seleccione
              </option>
              <option
                class=""
                *ngFor="let option of listaFuncionarios; let i = index"
                value="{{ option?.funcionario_id }}"
                [selected]="false"
              >
                {{ option?.nombres }} {{ option?.apellidos }}
              </option>
            </select>
          </div>
          <div class="form-group col-4">
            <label class="small text-secondary font-weight-bold mt-2"
              >Tipo de solicitud</label
            >
            <select
              class="form-control form-control-sm"
              id="tipo_solicitud_id"
              formControlName="tipo_solicitud_id"
            >
              <option class="" [ngValue]="null" selected="true">
                Seleccione
              </option>
              <option
                class=""
                *ngFor="let option of tipoSolicitudLista; let i = index"
                value="{{ option?.tipo_solicitud_id }}"
                [selected]="false"
              >
                {{ option?.descripcion }}
              </option>
            </select>
          </div>
          <div class="form-group col-4">
            <label class="small text-secondary font-weight-bold mt-2"
              >Número Radicado</label
            >
            <input
              class="form-control form-control-sm"
              id="funcionario"
              formControlName="radicado"
            />
          </div>
          <div class="form-group col-12 m-0 mt-1 text-center">
            <button
              class="btn btn-primary ml-1"
              type="submit"
              [disabled]="!formSolicitudActual.valid"
            >
              Consultar
            </button>
          </div>
        </div>
      </form>
      <div
        class="table-responsive"
        *ngIf="dataTabla.items?.length > 0; else no_data1"
      >
        <app-tablas
          [page]="paginaActual"
          [headers]="headersActuales"
          [sizeData]="dataTabla.paging.totalItems"
          (paginado)="onPaginado($event)"
          class="table-responsive"
        >
          <tr
            *ngFor="let item of dataTabla.items; let i = index"
            class="small"
            (click)="seleccionarActual(item.solicitud_id)"
          >
            <td>{{ item.codigo_rnt }}</td>
            <td>{{ item.abogado_nombres }}</td>
            <td>{{ item.nombre_establecimiento }}</td>
            <td>{{ item.numero_radicacion }}</td>
            <td>{{ item.fecha_radicacion | date: "d/MMM/yyyy, h:mm a" }}</td>
            <td>{{ item.tipo_solicitud_descripcion }}</td>
            <td>{{ item.observaciones }}</td>
            <td>
              <img
                src="../../../../../../../../assets/icons/checked_2.png"
                alt=""
                height="18"
                *ngIf="!item.estado"
              />
              <img
                src="../../../../../../../../assets/icons/checked.png"
                alt=""
                height="18"
                *ngIf="item.estado"
              />
            </td>
          </tr>
        </app-tablas>
      </div>
      <ng-template #no_data1>
        <section class="col p-2 mt-4 mb-2 bg-white">
          <header class="col-12">
            <figure class="figure w-100 text-center">
              <img
                class="img-fluid mb-4"
                src="../../../../../../../assets/images/sin_establecimiento.png"
              />
              <figcaption>
                <label class="h6 font-weight-bold"
                  >Sin solicitudes asignadas</label
                >
              </figcaption>
            </figure>
          </header>
        </section>
      </ng-template>
    </section>
    <section class="col-sm-12 col-md-1 align-self-center">
      <div class="form-row mb-2 justify-content-center">
        <button class="btn btn-primary" (click)="enviarSeleccionados()">
          <img
            class="pointer mr-1 ml-1"
            width="10"
            height="auto"
            src="../../../../../assets/icons/path-right.png"
          />
        </button>
      </div>
      <div class="form-row mb-2 justify-content-center">
        <button class="btn btn-primary" (click)="devolverSeleccionados()">
          <img
            class="pointer mr-1 ml-1"
            width="10"
            height="auto"
            src="../../../../../assets/icons/path-left.png"
          />
        </button>
      </div>
      <div class="form-row mb-2 justify-content-center">
        <button class="btn btn-primary" (click)="enviarTodo()">
          <img
            class="pointer mr-1"
            width="10"
            height="auto"
            src="../../../../../assets/icons/path-right.png"
          />
          <img
            class="pointer"
            width="10"
            height="auto"
            src="../../../../../assets/icons/path-right.png"
          />
        </button>
      </div>
      <div class="form-row mb-2 justify-content-center">
        <button class="btn btn-primary" (click)="devolverTodo()">
          <img
            class="pointer mr-1"
            width="10"
            height="auto"
            src="../../../../../assets/icons/path-left.png"
          />
          <img
            class="pointer"
            width="10"
            height="auto"
            src="../../../../../assets/icons/path-left.png"
          />
        </button>
      </div>
    </section>
    <section
      class="col-sm-12 col-md p-4 mt-5 mb-5 border-right bg-white shadow"
    >
      <img
        src="../../../../../assets/icons/solicitud.png"
        class="d-inline-block img-responsive mr-3"
        alt=""
      />
      <label class="h5">Solicitudes reasignadas</label>
      <form [formGroup]="formSolicitudReasignada" (ngSubmit)="enviarForm()">
        <div class="row">
          <!-- <div class="form-group col-6">
            <label class="small text-secondary font-weight-bold mt-2">Cámara de Comercio</label>
            <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
              <option class="" value="null" selected="true">
                Seleccione
              </option>
              <option class="" *ngFor="let option of camarasLista; let i = index" value="{{option?.codigo_camara}}" [selected]="false">
                    {{option?.desc_camara}}
                </option>
            </select>
          </div> -->
          <div class="form-group col-6">
            <label class="small text-secondary font-weight-bold mt-2"
              >Nuevo funcionario</label
            >
            <select
              class="form-control form-control-sm"
              id="funcionario"
              formControlName="funcionario"
            >
              <option class="" [ngValue]="null" selected="true">
                Seleccione
              </option>
              <option
                class=""
                *ngFor="
                  let option of listaFuncionariosReasignacion;
                  let i = index
                "
                value="{{ option?.funcionario_id }}"
                [selected]="false"
              >
                {{ option?.nombres }} {{ option?.apellidos }}
              </option>
            </select>
          </div>
          <div class="form-group col-6 m-0 mt">
            <button
              class="btn btn-primary ml-2"
              type="submit"
              [disabled]="!formSolicitudReasignada.valid"
            >
              Reasignar
            </button>
          </div>
        </div>
      </form>
      <div
        class="table-responsive"
        *ngIf="dataTabla2.items?.length > 0; else no_data"
      >
        <app-tablas
          [page]="paginaActual"
          [headers]="headersReasignacion"
          [sizeData]="1"
          (paginado)="onPaginado($event)"
          class="table-responsive"
        >
          <tr
            *ngFor="let item of dataTabla2.items; let i = index"
            class="small"
            (click)="seleccionarReasignado(item.solicitud_id)"
          >
            <td>{{ item.codigo_rnt }}</td>
            <td>{{ item.abogado_nombres }}</td>
            <td>{{ item.nombre_establecimiento }}</td>
            <td>{{ item.numero_radicacion }}</td>
            <td>{{ item.fecha_radicacion | date: "d/MMM/yyyy, h:mm a" }}</td>
            <td>{{ item.tipo_solicitud_descripcion }}</td>
            <td>{{ item.observaciones }}</td>
            <td>
              <img
                src="../../../../../../../../assets/icons/checked_2.png"
                alt=""
                height="18"
                *ngIf="!item.estado"
              />
              <img
                src="../../../../../../../../assets/icons/checked.png"
                alt=""
                height="18"
                *ngIf="item.estado"
              />
            </td>
          </tr>
        </app-tablas>
      </div>
      <ng-template #no_data>
        <section class="col p-2 mt-4 mb-2 bg-white">
          <header class="col-12">
            <figure class="figure w-100 text-center">
              <img
                class="img-fluid mb-4"
                src="../../../../../../../assets/images/sin_establecimiento.png"
              />
              <figcaption>
                <label class="h6 font-weight-bold"
                  >Sin solicitudes para reasignar</label
                >
              </figcaption>
            </figure>
          </header>
        </section>
      </ng-template>
    </section>
  </article>
</main>
